import Vue from 'vue'
import Vuex from 'vuex'
import Api from './api'
import { apiUrl } from "../../config"

Vue.use(Vuex)

const initDebugMode = (sessionStorage.getItem('debugMode') === 'true')
const initSelectedAccountID = sessionStorage.getItem('selectedAccountID')
const initSelectedProfileID = sessionStorage.getItem('selectedSAProfileID')

function initState(state) {
  state.partner = {}
  state.accounts = []
  state.settings = {}
  initStateAccount(state)
}

function initStateAccount(state) {
  state.account = {}
  state.profiles = []
  initStateProfile(state)
}

function initStateProfile(state) {
  state.profile = {}
  // Exposure
  state.exposure = {}
  // Remediation
  state.remediation = {}
  state.remediationLog = []
  // Assets
  state.assets = []
  state.assetsPage = 1
  state.assetsPages = 1
  state.assetsTotal = 0
  state.assetsFilter = {
    'type': '',
    'value': '',
    'sortAttr': 'state',
    'sortReverse': false
  }
  state.selectedAsset = ''
  // Alerts
  state.alerts = []
  state.alertsFilter = {
    'type': '',
    'value': '',
    'sortAttr': 'state',
    'sortReverse': false
  }
  state.alertsTotal = 0
  state.alertsStats = {}
  // Vulnerabilities
  state.vulnerabilities = []
  state.vulnerabilitiesFilter = {
    'type': '',
    'value': '',
    'sortAttr': 'total_alerts',
    'sortReverse': false
  }
  // Keywords
  state.keywords = []
  state.keywordsFilter = {
    'type': '',
    'value': '',
    'sortAttr': 'total_alerts',
    'sortReverse': false
  }
  // Activities
  state.activities = []
}

export default new Vuex.Store({
  state: {
    partnerMode: false,
    accountMode: false,
    debugMode: initDebugMode,
    apiPartner: null,
    apiAccount: null,
    settings: {},
    partner: {},
    accounts: [],
    account: {},
    profile: {},
    profiles: [],
    // Exposure
    exposure: {},
    // Remediation
    remediation: {},
    remediationLog: [],
    // Assets
    assets: [],
    assetsPage: 1,
    assetsPages: 1,
    assetsTotal: 0,
    assetsFilter: {
      'type': '',
      'value': '',
      'sortAttr': 'state',
      'sortReverse': false
    },
    selectedAsset: '',
    // Alerts
    alerts: [],
    assetsFilter: {
      'type': '',
      'value': '',
      'sortAttr': 'state',
      'sortReverse': false
    },
    alertsTotal: 0,//This is for filtered alerts above
    alertsLoading: false,
    alertsStats: {},
    // Vulnerabilities
    vulnerabilities: [],
    vulnerabilitiesFilter: {
      'type': '',
      'value': '',
      'sortAttr': 'total_alerts',
      'sortReverse': false
    },
    // Keywords
    keywords: [],
    keywordsFilter: {
      'type': '',
      'value': '',
      'sortAttr': 'total_alerts',
      'sortReverse': false
    },
    // Activities
    activities: []
  },


  /*
  Getters
  */
  getters: {
    getAccountById: (state) => (id) => {
      return state.accounts.find(account => account.id === id)
    },
    getProfileById: (state) => (id) => {
      return state.profiles.find(profile => profile.id === id)
    },
    getDefaultProfile: (state) => () => {
      return state.profiles.find(profile => profile.default)
    },
    getAlertById: (state) => (id) => {
      return state.alerts.find(alert => alert.id === id)
    }
  },


  /*
  Mutations
  */
  mutations: {
    initState (state) {
      // console.log('initState')
      initState(state)
    },
    initStateAccount (state) {
      // console.log('initStateAccount')
      initStateAccount(state)
    },
    initStateProfile (state) {
      // console.log('initStateProfile')
      initStateProfile(state)
    },
    setPartnerMode (state) {
      state.partnerMode = true
      state.accountMode = false
    },
    setAccountMode (state) {
      state.partnerMode = false
      state.accountMode = true
    },
    setDebugMode (state, debugMode) {
      // console.log('setPartnerApiKey', apiKey)
      sessionStorage.setItem('debugMode', debugMode)
      state.debugMode = debugMode
    },
    setPartnerApiKey (state, apiKey) {
      // console.log('setPartnerApiKey', apiKey)
      state.apiPartner = new Api(apiUrl, apiKey)
    },
    setAccountApiKey (state, apiKey) {
      // console.log('setAccountApiKey', apiKey)
      state.apiAccount = new Api(apiUrl, apiKey)
    },
    setPartner (state, partner) {
      // console.log('setPartner', partner)
      state.partner = partner
    },
    // Account
    setAccounts (state, accounts) {
      // console.log('setAccounts', accounts)
      state.accounts = accounts
    },
    setAccount (state, account) {
      // console.log('setAccount', account)
      sessionStorage.setItem('selectedAccountID', account.id)
      state.account = account
    },
    addAccount (state, account) {
      // console.log('addAccount', account)
      state.accounts.push(account)
    },
    removeAccount (state, account) {
      // console.log('removeAccount', account)
      var idx = state.accounts.findIndex(a => a.id === account.id)
      if (idx >= 0) state.accounts.splice(idx, 1)
    },
    // Settings
    setSettings (state, settings) {
      state.settings = settings
    },
    setAccountSettings (state, settings) {
      state.account.settings = settings
    },
    // Profiles
    setProfiles (state, profiles) {
      //console.log('setProfiles', profiles)      
      state.profiles = profiles
    },
    setProfile (state, profile) {
      // console.log('setProfile', profile)
      sessionStorage.setItem('selectedSAProfileID', profile.id)
      state.profile = profile
    },
    addProfile (state, profile) {
      // console.log('addProfile', profile)
      state.profiles.push(profile)
    },
    removeProfile (state, profile) {
      // console.log('removeProfile', profile)
      var idx = state.profiles.findIndex(p => p.id === profile.id)
      if (idx >= 0) state.profiles.splice(idx, 1)
      if (state.profile.id == profile.id) {
        state.profile = {}
      }
    },
    // Exposure
    setExposure (state, exposure) {
      // console.log('setExposure', exposure)
      state.exposure = exposure
    },
    // Remediation
    setRemediation (state, remediation) {
      // console.log('setRemediation', remediation)
      state.remediation = remediation
    },
    setRemediationLog (state, remediationLog) {
      state.remediationLog = remediationLog
    },
    addRemediation (state, remediation) {
      //console.log(state) 
      state.remediationLog.push(remediation)
      for(var i=0;i<state.remediation.remediations.length;i++) {
        if(state.remediation.remediations[i].alert_ids == remediation.alert_ids) {
          state.remediation.remediations.splice(i,1)
        }
      }      
    },
    deleteRemediation (state, remediation) {
      // console.log('deleteRemediation', remediation)
      //Set remediation to NULL so that it will not show
      remediation.id = null      
      remediation.username = null
      state.remediation.remediations.push(remediation)
      for(var i=0;i<state.remediationLog.length;i++) {
        if(state.remediationLog[i].alert_ids == remediation.alert_ids) {
          state.remediationLog.splice(i,1)
        }
      }
      //loadRemediation();      
    },
    // Assets
    setAssets (state, assets) {
      state.assets = assets
      // console.log('setAssets',state.assets)
    },
    setAsset(state, asset) {
      var tempAssets = []
      for (var i in state.assets) {
        console.log('setAsset:'+state.assets[i].id+' == '+asset.id)
        if(state.assets[i].id == asset.id) {
          tempAssets.push(asset)
          console.log("setAsset Updated asset = " + state.assets[i].id)
        }
        else {
          tempAssets.push(state.assets[i])
        }        
      }
      state.assets = tempAssets
    },
    addAssets (state, assets) {
      // console.log('addAssets', assets)
     for (var asset in assets) {
       assets[asset].selected = false
       state.assets.push(assets[asset])
     }
   },
    // Vulneabilities
    addVulnerability (state, vulnerability) {
      // console.log('addKeyword', keyword)    
      state.vulnerabilities.push(vulnerability)
    },
    setVulnerabilities (state, vulnerabilities) {
      // console.log('setVulnerabilities', vulnerabilities)
      // for (var vulnerability in vulnerabilities) {
      //   vulnerabilities[vulnerability].selected = false
      // }
      state.vulnerabilities = vulnerabilities
    },
    // Keywords
    setKeywords (state, keywords) {
      // console.log('setKeywords', keywords)
      for (var keyword in keywords) {
        keywords[keyword].selected = false
      }
      state.keywords = keywords
    },
    addKeywords (state, keywords) {
       console.log('addKeywords', keywords)
      for (var keyword in keywords) {
        keywords[keyword].selected = false
        state.keywords.push(keywords[keyword])
      }
    },
    addKeyword (state, keyword) {
     // console.log('addKeyword', keyword)    
     state.keywords.push(keyword)
   },
    removeKeyword (state, keyword) {
      // console.log('removeKeyword', keyword)
      var idx = state.keywords.findIndex(k => k.id === keyword.id)
      if (idx >= 0) state.keywords.splice(idx, 1)
    },
    // Alerts
    setAlerts (state, alerts) {
      // console.log('setAlerts', alerts)
      state.alerts = alerts
    },
    // Activities
    setActivities (state, activities) {
      state.activities = activities
      // console.log('setActivities',state.activities)
    }
  },
  
  /*
  Actions
  */
  actions: {
    setApiKey ({ commit, dispatch }, apiKey) {
      // console.log('setApiKey', apiKey)
      if (apiKey.length == 48) {
        commit('setPartnerMode')
        commit('initState')
        commit('setPartnerApiKey', apiKey)
        dispatch('loadPartner')
        //dispatch('loadPartnerSettings')
        dispatch('loadAccounts')
        return
      }
      if (apiKey.length == 32 || apiKey == 'demo-api-key') {
        commit('setAccountMode')
        commit('initState')
        commit('setAccountApiKey', apiKey)
        dispatch('loadAccount')
        //dispatch('loadAccountSettings')
        return
      }
      commit('initState')
    },
    loadPartner ({ state, commit }) {
      // console.log('loadPartner')
      state.apiPartner.get('/partner')
        .then(partner => {
          // console.log('Loaded partner', response)
          commit('setPartner', partner)
        })
    },
    loadPartnerSettings ({ state, commit }) {
      // console.log('loadPartnerSettings')
      state.apiPartner.get('/settings')
        .then(settings => {
          // console.log('Loaded settings', settings)
          commit('setSettings', settings)
        })
    },
    loadAccounts ({ state, commit, getters, dispatch }) {
      // console.log('loadAccounts')
      state.apiPartner.get('/accounts')
        .then(response => {
          // console.log('Loaded accounts', response)
          commit('setAccounts', response.accounts)
          // Select init account or default
          var account = getters.getAccountById(initSelectedAccountID)
          if (account) {
            dispatch('selectAccount', account)
          } else {
            dispatch('selectAccount', state.accounts[0])
          }
        })
    },
    loadAccount ({ state, commit, dispatch }) {
      // console.log('loadAccount')
      state.apiAccount.get('/account')
        .then(account => {
          // console.log('Loaded account', account)
          commit('setAccounts', [account])
          dispatch('selectAccount', account)
        })
    },
    loadAccountSettings ({ state, commit }) {
      // console.log('loadAccountSettings')
      state.apiAccount.get('/settings')
        .then(settings => {
          // console.log('Loaded settings', settings)
          commit('setSettings', settings)
        })
    },
    selectAccount ({ commit, getters, dispatch }, account) {
      // console.log('selectAccount', account)
      commit('initStateAccount')
      commit('setAccountApiKey', account.api_keys[0].key)
      commit('setAccount', account)
      commit('setProfiles', account.profiles)
      dispatch('selectProfile', getters.getDefaultProfile())
      // dispatch('loadProfiles')
    },
    createAccount ({ state, commit }, params) {
      // console.log('createAccount', params)
      state.apiPartner.post('/accounts', params).then(account => {
          commit('addAccount', account)
        }).catch( error => {
          // console.log(error)
          alert(error.response.data.message)
        })
    },
    updateAccount ({ state }, { account, params}) {
      // console.log('updateAccount', account, params)
      state.apiPartner.put('/accounts/' + account.id, params).then(updatedAccount => {
          Object.assign(account, updatedAccount)
        }).catch( () => {
          // console.log(error)
          alert('Faield to update account')
        })
    },
    deleteAccount ({ state, commit }, account) {
      // console.log('deleteAccount', account)
      state.apiPartner.delete('/accounts/' + account.id).then( () => {
          commit('removeAccount', account)
        })
    },
    saveAccount ({ state, commit }) {
      // console.log('saveAccount')
      state.apiAccount.put('/account', {
        name: state.account.name,
        sector: state.account.sector,
        employees: state.account.employees
      }).then(account => {
          commit('setAccount', account)
      })
    },

    /*
    Settings
    */
    loadSettings ({ state, commit}) {
      // console.log('loadSettings')
      let api = state.apiPartner ? state.apiPartner : state.apiAccount
      api.get('/settings')
        .then(settings => {
          // console.log('Loaded settings', settings)
          commit('setSettings', settings)
        })
    },
    saveSettings ({ state, commit }, params) {
      // console.log('Save settings', params)
      let api = state.apiPartner ? state.apiPartner : state.apiAccount
      api.put('/settings', params).then(settings => {
        commit('setSettings', settings)
      }).catch( () => {
          // console.log(error)
          alert('Failed to save settings')
        })
    },
    saveAccountSettings ({ commit }, { account, params }) {
      // console.log('Save account settings', account, params)
      let api = new Api(apiUrl, account.api_keys[0].key)
      api.put('/settings', params).then(settings => {
        // console.log('Saved settings', settings)
        // commit('setAccountSettings', settings)
        account.settings = settings
      }).catch( () => {
          // console.log(error)
          alert('Failed to save settings')
        })
    },

    /*
    Profiles
    */
    loadProfiles ({ state, commit, getters, dispatch }) {
      // console.log('loadProfiles')
      state.apiAccount.get('/profiles')
        .then(response => {
          // console.log('Loaded profiles', response)
          commit('setProfiles', response.profiles)
          // Select init profile or default
          var profile = getters.getProfileById(initSelectedProfileID)
          if (profile) {
            dispatch('selectProfile', profile)
          } else {
            commit('setProfile', getters.getDefaultProfile())
          }
        })
    },
    selectProfile ({ commit }, profile) {
      // console.log('selectProfile', profile)
      commit('initStateProfile')
      commit('setProfile', profile)
    },
    createProfile ({ state, commit }, params) {
      // console.log('createProfile', params)
      state.apiAccount.post('/profiles', params).then(profile => {
          commit('addProfile', profile)
        })
    },
    updateProfile ({ state }, { profile, params}) {
      // console.log('updateProfile', profile, params)
      state.apiAccount.put('/profiles/' + profile.id, params).then(updatedProfile => {
          // commit('addProfile', profile)
          profile.name = updatedProfile.name
        }).catch( () => {
          // console.log(error)
          alert('Failed to update profile')
        })
    },
    deleteProfile ({ state, commit }, profile) {
      // console.log('deleteProfile', profile)
      state.apiAccount.delete('/profiles/' + profile.id).then( () => {
          commit('removeProfile', profile)
        })
    },
    resetProfile ({ state, commit }, profile) {
      // console.log('resetProfile', profile)
      state.apiAccount.post('/profiles/' + profile.id + '/reset')
    },

    /*
    Exposure
    */
    loadExposure ({ state, commit }) {
      // console.log('loadExposure')
      // Clear exposure
      commit('setExposure', {})
      // Get from API
      var params = {}
      if (state.profile) params['profile_id'] = state.profile.id
      state.apiAccount.get('/exposure', params)
        .then(exposure => {
          commit('setExposure', exposure)
        })
    },

    /*
    Remediation
    */
    loadRemediation ({ state, commit }) {
      // console.log('loadRemediation')
      // Clear remediation
      commit('setRemediation', {})
      // Get from API
      var params = {}
      if (state.profile) params['profile_id'] = state.profile.id
      state.apiAccount.get('/remediation', params)
        .then(response => {
          // console.log(response)
          commit('setRemediation', response)
        })
    },

    loadRemediationLog ({ state, commit }) {
      // console.log('loadRemediationLog')
      // Clear remediation
      commit('setRemediationLog', {})
      // Get from API
      var params = {}
      if (state.profile) params['profile_id'] = state.profile.id
      state.apiAccount.get('/remediation/log', params)
        .then(response => {
          // console.log(response)
          commit('setRemediationLog', response.remediations)
        })
    },
    createRemediation ({ state ,commit}, { remediation, params}) { 
             
        state.apiAccount.post('/remediation', params).then(RespRemediation => {
          RespRemediation.alert_ids = remediation.alert_ids
          commit('addRemediation', RespRemediation)
        })            
    },
    removeRemediation ({ state ,commit},  remediation) {   
      // console.log('Delete', remediation)
      state.apiAccount.delete('/remediation/'+remediation.id).then( () => {
        commit('deleteRemediation', remediation)
      })      
    },

    /*
    Assets
    */
    loadAssets ({ state, commit }, parm) {
      // console.log('loadAssets')
      // console.log(all)
      // Clear remediation
      state.assetsPage = 1
      commit('setAssets', {})
      // Get from API
      var params = {}
      if (state.profile) params['profile_id'] = state.profile.id
      if (parm['all']='false') params['page'] = state.assetsPage
      if (parm['state']) params['state'] = parm['state']
      if (parm['level']) params['level'] = parm['level']
      if (parm['type']) params['group_by'] = parm['type']
      if (parm['manuallyAdded']) params['manually_added'] = parm['manuallyAdded']
      state.apiAccount.get('/assets', params)
        .then(response => {
          // console.log('loadAssets',response)
          console.log('loadAssets page =', state.assetsPage)
          state.assetsPage = response.page
          state.assetsPages = response.pages
          state.assetsTotal = response.total
          commit('setAssets', response.assets)
        })
    },
    loadNextAssets ({ state, commit }) {
      commit('setAssets', {})
      // Get next page from API
      var params = {}
      if (state.profile) params['profile_id'] = state.profile.id
      params['page'] = state.assetsPage + 1
      state.apiAccount.get('/assets', params)
        .then(response => {
          // console.log('loadAssets',response)
          state.assetsPage = response.page
          state.assetsPages = response.pages
          state.assetsTotal = response.total
          commit('setAssets', response.assets)
        })
    },
    loadPrevAssets ({ state, commit }) {
      commit('setAssets', {})
      // Get previous page from API
      var params = {}
      if (state.profile) params['profile_id'] = state.profile.id
      params['page'] = state.assetsPage - 1
      state.apiAccount.get('/assets', params)
        .then(response => {
          // console.log('loadAssets',response)
          state.assetsPage = response.page
          state.assetsPages = response.pages
          state.assetsTotal = response.total
          commit('setAssets', response.assets)
        })
    },
    loadAsset ({ state, commit }, {asset}){
      // console.log('loadAsset')
      // Clear remediation
      // commit('setAssets', {})
      // Get from API
      var params = {}
      if (state.profile) params['profile_id'] = state.profile.id
      state.apiAccount.get('/assets/' + asset.id, params)
        .then(response => {
          console.log('loadAsset',response)
          commit('setAsset', response)
        })
    },
    createAsset ({ state, commit }, params) {
      // console.log('createAsset', params)
      if (state.profile) params['profile_id'] = state.profile.id
      state.apiAccount.post('/assets', params)
        .then(asset => {
          commit('addKeyword', asset)
        })
        .catch(error => {
        if (error.response.status === 409) {
          alert('Asset already exists')
        }
        return {}
      })
    },
    updateAsset ({ state, commit}, { asset, params}) { 
      state.apiAccount.put('/assets/' + asset.id, params).then(updatedAsset => {
        //commit('setAssets', updatedAsset)
      })
    },
    discoverAsset ({ state, commit}, { asset, params}) { 
      state.apiAccount.post('/assets/' + asset.id + '/discover', params).then(updatedAsset => {
        //commit('setAssets', updatedAsset)
      })
    },
    monitorAsset ({ state, commit}, { asset, params}) { 
      state.apiAccount.post('/assets/' + asset.id + '/monitor', params).then(updatedAsset => {
        //commit('setAssets', updatedAsset)
      })
    },
    scanAsset ({ state, commit}, { asset, params}) { 
      state.apiAccount.post('/vulnerability/' + asset.id + '/scan', params).then(updatedAsset => {
        //commit('setAssets', updatedAsset)
      })
    },
    jsonReport ({ state, commit}, { asset, params}) { 
      state.apiAccount.download('/assets/' + asset.id + '/scans/latest/report?format=JSON', 'report.json')
    },
    pdfReport ({ state, commit}, { asset, params}) { 
      state.apiAccount.download('/reporting/assets/' + asset.id + '/vulnerabilities', 'report.pdf')
    },
    selectAsset ({ state, commit}, { assetId}) {
      // console.log('selectAsset() : assetID = '+assetId)
      state.selectedAsset = assetId  
    },
    deleteAsset ({ state, commit}, { asset, params}) { 
      state.apiAccount.delete('/assets/' + asset.id, params).then(updatedAsset => {
        //commit('setAssets', updatedAsset)
      })
    },

    /* 
    Keywords 
    */
    loadKeywords ({ state, commit }) {
      // console.log('loadKeywords')
      // Clear keywords
      commit('setKeywords', [])
      // Get from API
      var params = {}
      if (state.profile) params['profile_id'] = state.profile.id
      state.apiAccount.get('/keywords', params)
        .then(keywords => {
          //commit('setKeywords', keywords.keywords)
          commit('setKeywords', keywords)
        })
    },
    updateKeywords ({ state, commit}, params) {
      if (state.profile) params['profile_id'] = state.profile.id
      state.apiAccount.put('/keywords', params)
        .then( response => {
          commit('setKeywords', response.keywords)
        })
    },
    deleteKeywords ({ state, commit}) {
      var url = '/keywords'
      if (state.profile) url += '?profile_id=' + state.profile.id
      state.apiAccount.delete(url)
        .then( keywords => {
          commit('setKeywords', keywords)
        })
    },
    createKeyword ({ state, commit }, params) {
      // console.log('createKeyword', params)
      if (state.profile) params['profile_id'] = state.profile.id
      state.apiAccount.post('/keywords', params)
        .then(keyword => {
          commit('addKeyword', keyword)
        })
        .catch(error => {
        if (error.response.status === 409) {
          alert('Keyword already exists')
        }
        return {}
      })
    },
    updateKeyword ({ state }, keyword) {
      // console.log('updateKeyword', keyword)
      state.apiAccount.post('/keywords/' + keyword.id + '/update', {
        force_update: true
      })
    },
    discoverKeyword ({ state }, keyword) {
      // console.log('discoverKeyword', keyword)
      state.apiAccount.post('/keywords/' + keyword.id + '/discover', {
        force_update: true
      })
    },
    resetKeyword ({ state }, keyword) {
      // console.log('resetKeyword', keyword)
      state.apiAccount.post('/keywords/' + keyword.id + '/reset')
    },
    deleteKeyword ({ state, commit}, keyword) {
      // console.log('deleteKeyword', keyword)
      state.apiAccount.delete('/keywords/' + keyword.id)
        .then( () => {
          commit('removeKeyword', keyword)
        })
    },

    /*
    Alerts
    */
   loadAlerts ({ state, commit }) {
    // console.log('loadAlerts')
    // Clear alerts
    commit('setAlerts', {})
    // Get from API
    var params = {}
    if (state.profile) params['profile_id'] = state.profile.id
    state.apiAccount.get('/alerts', params)
      .then(response => {
        // console.log('loadAlerts',response)
        commit('setAlerts', response.alerts)
      })
  },

  /*
  Vulnerabilities
  */
 loadVulnerabilities ({ state, commit }) {
  // console.log('loadVulnerabilities')
  // Clear keywords
  commit('setVulnerabilities', [])
  // Get from API
  var params = {}
  if (state.profile) params['profile_id'] = state.profile.id
  state.apiAccount.get('/vulnerability', params)
    .then(response => {
      commit('setVulnerabilities', response.vulnerabilities)
    })
  },
  createVulnerability ({ state, commit }, params) {
    // console.log('createKeyword', params)
    if (state.profile) params['profile_id'] = state.profile.id
    console.log('Create Vulnerability State.profile ='+state.apiAccount)
    console.log('Create Vulnerability State.apiaccount ='+state.apiAccount)
    state.apiAccount.post('/vulnerability', params)
      .then(vulnerability => {
        commit('addVulnerability', vulnerability)
      })
      .catch(error => {
      if (error.response.status === 409) {
        alert('Vulnerability already exists')
      }
      return {}
    })
  },

    /*
    Activities
    */
    loadActivities ({ state, commit }) {
      // console.log('loadActivities')
      commit('setActivities', {})
      // Get from API
      var params = {}
      if (state.profile) params['profile_id'] = state.profile.id
      state.apiAccount.get('/assets/log', params)
        .then(response => {
          // console.log('loadActivities',response)
          commit('setActivities', response.entries)
        })
    }
    
  }
})
